import CardPagos from './CardPagos';

export default CardPagos;